export const skipLocationChange = false;

export enum GithubPopupTpl {
  default = 'header_default',
  children = 'header_children'
}
